<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — MONITOR DE TRANSFERÊNCIAS" titleIcon="fas fa-exchange-alt">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Instituição (origem ou destino)">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas" filterable clearable style="width:100%;" @change="load(1)">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Produto">
                            <el-select v-model="filtro.produto_id" placeholder="Todos" filterable remote clearable :remote-method="buscarProduto" :loading="loadingProd" style="width:100%;" @change="load(1)">
                                <el-option v-for="p in produtosBusca" :key="p.id" :label="`${p.codigo} — ${p.nome}`" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período">
                            <el-date-picker v-model="periodo" type="daterange" value-format="yyyy-MM-dd" format="dd/MM/yyyy" range-separator="até" start-placeholder="Início" end-placeholder="Fim" style="width:100%;" @change="onPeriodo"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 150px;">Data</th>
                            <th>Produto</th>
                            <th>Origem</th>
                            <th>Destino</th>
                            <th style="width: 110px;" class="u-text-right">Quantidade</th>
                            <th class="hidden-mobile">Documento</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="m in items" :key="m.id">
                            <td>{{ m.data_movimento | formatarDt }}</td>
                            <td>{{ m.produto ? m.produto.nome : '—' }}</td>
                            <td>{{ m.instituicao ? m.instituicao.nome : '—' }}</td>
                            <td>{{ m.destino ? m.destino.nome : '—' }}</td>
                            <td class="u-text-right">{{ Number(m.quantidade).toFixed(3) }}</td>
                            <td class="hidden-mobile">{{ m.documento || '—' }}</td>
                        </tr>
                        <tr v-if="!items.length"><td colspan="6" class="u-text-center" style="padding: 15px; color: #909399;">Nenhuma transferência encontrada.</td></tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="load" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarDt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '' } },
    data: () => ({
        statusList: false,
        loadingProd: false,
        produtosBusca: [],
        periodo: [],
        filtro: { instituicao_id: '', produto_id: '', data_inicio: '', data_fim: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: []
    }),
    mounted () { this.load(1) },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        onPeriodo () {
            this.filtro.data_inicio = (this.periodo && this.periodo[0]) || ''
            this.filtro.data_fim = (this.periodo && this.periodo[1]) || ''
            this.load(1)
        },
        buscarProduto (q) {
            if (!q || q.length < 2) return
            this.loadingProd = true
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/getAllPaginate`, { busca: q, situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.produtosBusca = (r.data && r.data.data) ? r.data.data : []; this.loadingProd = false })
                .catch(() => { this.loadingProd = false })
        },
        load (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/transferencias?page=${this.paginate.page}`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        }
    }
}
</script>
